import { render, staticRenderFns } from "./ExportDev.vue?vue&type=template&id=2dcfcbda&scoped=true&"
import script from "./ExportDev.vue?vue&type=script&lang=js&"
export * from "./ExportDev.vue?vue&type=script&lang=js&"
import style0 from "./ExportDev.vue?vue&type=style&index=0&id=2dcfcbda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcfcbda",
  null
  
)

export default component.exports